<template>
    <!-- The On-Demand form from the report designs: a grid of cards, a third
         and two thirds wide (the left never narrower than the date picker).
         The run-options form (Period, Points) and the report's settings land in
         it as cards without the report doing anything: everything rendered in
         this slot is told to use the card style (see provide). -->
    <!-- A report with nothing to pick (no period, no points) has only settings
         cards, so they stack full width instead. -->
    <!-- And a report whose only card is the Period picker centres it. -->
    <!-- With no Period card, Points takes the wide right column and the
         settings cards fill the left (dense flow lets them move up beside it). -->
    <div    :class="centered
                ? 'flex justify-center'
                : ['grid grid-cols-1 items-start gap-6', { 'lg:grid-cols-[minmax(min-content,1fr)_minmax(0,2fr)] lg:grid-flow-row-dense': ! singleColumn }]"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "ReportCardGrid",
    props: {
        // Shared with the page header's Run Report button: the form inside the
        // grid registers its run state and run action here.
        run: {
            type: Object,
            required: true,
        },
        singleColumn: {
            type: Boolean,
            default: false,
        },
        centered: {
            type: Boolean,
            default: false,
        },
        // The report has settings cards, so a Points card with no Period
        // beside it sits next to them instead of taking the full width.
        hasSettings: {
            type: Boolean,
            default: false,
        },
    },
    provide() {
        return {
            reportSettingsVariant: 'cards',
            reportFormLayout: 'cards',
            reportRun: this.run,
            reportGridHasSettings: () => this.hasSettings,
        }
    },
}
</script>
